import type { TypedCompilerError } from "./types"

export class CompilerClientError extends Error implements TypedCompilerError {
  code: string
  status?: number
  details?: string
  override cause?: unknown

  constructor(
    message: string,
    options: {
      code: string
      status?: number
      details?: string
      cause?: unknown
    },
  ) {
    super(message)
    this.name = "CompilerClientError"
    this.code = options.code
    this.status = options.status
    this.details = options.details
    this.cause = options.cause
  }
}

export function toCompilerError(
  error: unknown,
  fallbackCode = "UNKNOWN_ERROR",
  fallbackMessage = "Unexpected compiler client error",
): CompilerClientError {
  if (error instanceof CompilerClientError) return error
  if (error instanceof Error) {
    return new CompilerClientError(error.message || fallbackMessage, {
      code: fallbackCode,
      cause: error,
    })
  }

  return new CompilerClientError(fallbackMessage, {
    code: fallbackCode,
    cause: error,
  })
}
